import React, { Component, Fragment } from 'react';
import Dropzone from 'react-dropzone';
import DtnPhotoModal from './DtnPhotoModal';
import UserPreferenceService from '../../../../services/UserPreferenceService';
import axios from 'axios';

class DtnPhotos extends Component {
    constructor(props) {
        super(props);

        this.userPreferenceService = new UserPreferenceService();
        this.userPreferenceService.addChangeListener(this.handlePreferencesChanged);

        this.state = {
            loading: false,
            imageLineCount: this.userPreferenceService.get('dtnImageLineCount') || 3,
            dtnImageModalOpen: false,
            dtnImageModalIndex: 0,
            selectedImages: new Set(),
            isDragOver: false,
            media: Array.isArray(props.media) ? props.media : props.media ? [props.media] : [],
        };
    }

    componentDidMount() {
        $('[data-bs-toggle="tooltip"]').tooltip();
        const scrollPos = sessionStorage.getItem('dtnScrollPos');
        if (scrollPos) {
            window.scrollTo(0, parseInt(scrollPos));
            sessionStorage.removeItem('dtnScrollPos');
        }
    }

    componentDidUpdate() {
        $('[data-bs-toggle="tooltip"]').tooltip();
    }

    componentWillUnmount() {
        this.userPreferenceService.removeChangeListener(this.handlePreferencesChanged);
        this.stopEdgeScroll();
    }

    handleImageRotation = (imageId, rotation) => {
        this.setState({ loading: true });

        let imageData = new FormData();
        imageData.append('image_id', imageId);
        imageData.append('rotation', rotation);
        imageData.append('_method', 'PATCH');

        axios
            .post(`media/${imageId}/rotate`, imageData)
            .then(() => {
                sessionStorage.setItem('dtnScrollPos', window.scrollY);
                window.location.reload();
            })
            .catch((err) => {
                console.error(err);
                this.setState({ loading: false });
            });
    };

    handleImageLine = (count) => {
        this.setState({ imageLineCount: count });
        this.userPreferenceService.set('dtnImageLineCount', count);
    };

    handlePreferencesChanged = (obj) => {
        if (obj.dtnImageLineCount !== this.state.imageLineCount) {
            this.setState({ imageLineCount: obj.dtnImageLineCount });
        }
    };

    handleDragStart = (e, imageId) => {
        e.dataTransfer.setData('imageId', imageId);
        e.dataTransfer.setData('fromSection', this.props.name);
        e.dataTransfer.setData('fromJobId', String(this.props.jobId));
        e.dataTransfer.effectAllowed = 'move';
        this.startEdgeScroll();
    };

    handleDragEnd = () => {
        this.stopEdgeScroll();
    };

    startEdgeScroll = () => {
        const threshold = 120;
        const maxSpeed = 20;

        this._edgeScrollHandler = (e) => {
            const y = e.clientY;
            const viewportHeight = window.innerHeight;

            if (this._edgeScrollFrame) {
                cancelAnimationFrame(this._edgeScrollFrame);
                this._edgeScrollFrame = null;
            }

            if (y < threshold) {
                const speed = maxSpeed * (1 - y / threshold);
                this._edgeScrollFrame = requestAnimationFrame(() => window.scrollBy(0, -speed));
            } else if (y > viewportHeight - threshold) {
                const speed = maxSpeed * ((y - (viewportHeight - threshold)) / threshold);
                this._edgeScrollFrame = requestAnimationFrame(() => window.scrollBy(0, speed));
            }
        };

        document.addEventListener('dragover', this._edgeScrollHandler);
    };

    stopEdgeScroll = () => {
        if (this._edgeScrollHandler) {
            document.removeEventListener('dragover', this._edgeScrollHandler);
            this._edgeScrollHandler = null;
        }
        if (this._edgeScrollFrame) {
            cancelAnimationFrame(this._edgeScrollFrame);
            this._edgeScrollFrame = null;
        }
    };

    handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        this.setState({ isDragOver: true });
    };

    handleDragLeave = (e) => {
        if (e.currentTarget.contains(e.relatedTarget)) return;
        this.setState({ isDragOver: false });
    };

    sectionCategoryMap = {
        images_before: { category: 'area', period: 'before' },
        images_after: { category: 'area', period: 'after' },
        van_images_before: { category: 'van', period: 'before' },
        van_images_after: { category: 'van', period: 'after' },
    };

    sectionLabels = {
        images_before: 'Area photos before',
        images_after: 'Area photos after',
        van_images_before: 'Van photos before',
        van_images_after: 'Van photos after',
    };

    handleDrop = (e) => {
        const rawImageId = e.dataTransfer.getData('imageId');

        // New file upload: let Dropzone handle it
        if (!rawImageId) return;

        e.preventDefault();
        this.stopEdgeScroll();
        this.setState({ isDragOver: false });

        const imageId = parseInt(rawImageId, 10);
        const fromSection = e.dataTransfer.getData('fromSection');
        const fromJobId = e.dataTransfer.getData('fromJobId');
        const toSection = this.props.name;

        if (Number.isNaN(imageId)) return;
        if (!this.sectionCategoryMap[toSection]) return;

        const isSameJob = String(fromJobId) === String(this.props.jobId);
        if (isSameJob && fromSection === toSection) return;

        const { category, period } = this.sectionCategoryMap[toSection];

        sessionStorage.setItem('dtnScrollPos', window.scrollY);

        axios
            .patch(`/jobs/${this.props.jobId}/dtn/media/${imageId}/move`, { category, period })
            .then(() => window.location.reload())
            .catch(() => toastr.error('Failed to move image. Please try again.'));
    };
    toggleSelectImage = (imageId) => {
        this.setState((prevState) => {
            const selectedImages = new Set(prevState.selectedImages);
            if (selectedImages.has(imageId)) {
                selectedImages.delete(imageId);
            } else {
                selectedImages.add(imageId);
            }
            return { selectedImages };
        });
    };

    deleteSelectedImages = () => {
        const { selectedImages } = this.state;
        if (selectedImages.size === 0) return;

        this.setState({ loading: true });

        Promise.all(
            Array.from(selectedImages).map((id) =>
                axios.delete(`media/${id}`).then(() => {
                    this.setState((prevState) => ({
                        media: prevState.media.filter((m) => m.id !== id),
                    }));
                })
            )
        )
            .then(() => this.setState({ selectedImages: new Set(), loading: false }))
            .catch(() => this.setState({ loading: false }));
    };

    moveSelectedImages = (toSection) => {
        const { selectedImages } = this.state;
        if (selectedImages.size === 0 || !this.sectionCategoryMap[toSection]) return;

        const { category, period } = this.sectionCategoryMap[toSection];

        this.setState({ loading: true });
        sessionStorage.setItem('dtnScrollPos', window.scrollY);

        Promise.all(
            Array.from(selectedImages).map((id) =>
                axios.patch(`/jobs/${this.props.jobId}/dtn/media/${id}/move`, { category, period })
            )
        )
            .then(() => window.location.reload())
            .catch(() => {
                toastr.error('Failed to move images. Please try again.');
                this.setState({ loading: false });
            });
    };

    render() {
        const { imageLineCount, selectedImages, media, isDragOver } = this.state;
        const isDraggable = !!this.props.jobId && !!this.sectionCategoryMap[this.props.name];

        return (
            <Fragment>
                <div
                    className={isDragOver ? 'dtn-drag-over' : undefined}
                    onDragOver={isDraggable ? this.handleDragOver : undefined}
                    onDragLeave={isDraggable ? this.handleDragLeave : undefined}
                    onDrop={isDraggable ? this.handleDrop : undefined}
                >
                <div className="row pb-3 mt-4">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">{this.props.title}</h6>
                        <div className="section-controls-holder">
                            <div className="dropleft">
                                <button
                                    className="btn btn-outline-light btn-sm section-control-button"
                                    id={`view-options-button-${this.props.name}`}
                                    data-toggle="dropdown"
                                    data-bs-toggle="tooltip"
                                    data-placement="top"
                                    title="View options"
                                    type="button"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <i className="fas fa-search-plus" aria-hidden="true" />
                                </button>
                                <ul
                                    className="dropdown-menu dropdown-menu-left"
                                    aria-labelledby={`view-options-button-${this.props.name}`}
                                >
                                    {[3, 4, 6, 8].map((count) => (
                                        <li key={count}>
                                            <button
                                                type="button"
                                                className="dropdown-item"
                                                onClick={() => this.handleImageLine(count)}
                                            >
                                                {count} images per line
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {selectedImages.size > 0 && (
                    <div className="row mb-2">
                        <div className="col-12">
                            <button
                                className="btn btn-danger mr-2"
                                onClick={this.deleteSelectedImages}
                                disabled={this.state.loading}
                            >
                                Delete Selected ({selectedImages.size})
                            </button>

                            {isDraggable && (
                                <div className="dropdown d-inline-block">
                                    <button
                                        className="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        id={`move-selected-button-${this.props.name}`}
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        disabled={this.state.loading}
                                    >
                                        Move Selected ({selectedImages.size})
                                    </button>
                                    <div
                                        className="dropdown-menu"
                                        aria-labelledby={`move-selected-button-${this.props.name}`}
                                    >
                                        {Object.keys(this.sectionCategoryMap)
                                            .filter((section) => section !== this.props.name)
                                            .map((section) => (
                                                <button
                                                    key={section}
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={() => this.moveSelectedImages(section)}
                                                >
                                                    {this.sectionLabels[section]}
                                                </button>
                                            ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div className="row">
                    {media.map((image, index) => {
                        return (
                            <Fragment key={image.id}>
                                {index > 0 && index < media.length && index % imageLineCount === 0 && (
                                    <div className="w-100 photo-spacer"></div>
                                )}
                                <div
                                    className="col-md mb-2"
                                    draggable={isDraggable}
                                    onDragStart={isDraggable ? (e) => this.handleDragStart(e, image.id) : undefined}
                                    onDragEnd={isDraggable ? this.handleDragEnd : undefined}
                                >
                                    <div className="delete-button-holder">
                                        <input
                                            type="checkbox"
                                            checked={selectedImages.has(image.id)}
                                            onChange={() => this.toggleSelectImage(image.id)}
                                        />
                                    </div>

                                    <div className="rotation-buttons-holder">
                                        <button
                                            className="image-manipulation-button"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Rotate image left"
                                            onClick={() => this.handleImageRotation(image.id, -90)}
                                            type="button"
                                            disabled={this.state.loading}
                                        >
                                            <i className="fas fa-undo" aria-hidden="true"></i>
                                        </button>
                                        <button
                                            className="image-manipulation-button"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Rotate image right"
                                            onClick={() => this.handleImageRotation(image.id, 90)}
                                            type="button"
                                            disabled={this.state.loading}
                                        >
                                            <i className="fas fa-redo" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <img
                                        src={image.url}
                                        className="img-fluid"
                                        alt=""
                                        draggable={false}
                                        onClick={() =>
                                            this.setState({ dtnImageModalOpen: true, dtnImageModalIndex: index })
                                        }
                                    />
                                </div>
                            </Fragment>
                        );
                    })}

                    {media.length % imageLineCount !== 0 &&
                        Array(imageLineCount - (media.length % imageLineCount))
                            .fill()
                            .map((_, i) => <div className="col-md mb-2 invisible" key={`empty-${i}`}></div>)}
                </div>

                <div className="row">
                    <div className="col-12">
                        <Dropzone
                            onDrop={(acceptedFiles) => this.props.onDrop(acceptedFiles, this.props.name)}
                            multiple={this.props.multiple}
                            onDropRejected={(rejectedFiles) => this.props.onDropReject(rejectedFiles, this.props.name)}
                            maxSize={15000000}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <section>
                                    <div {...getRootProps()} className="d-flex flex-column align-items-center jobs-dropzone">
                                        <input {...getInputProps()} />
                                        {this.props.acceptedFiles.length > 0 ? (
                                            <div className="row w-100">
                                                {this.props.acceptedFiles.map((file, index) => (
                                                    <div key={index} className="col-md-2 d-flex flex-column justify-content-between">
                                                        <img src={window.URL.createObjectURL(file)} className="img-fluid" />
                                                        <div
                                                            className="text-center dropzone-remove-link"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                this.props.removeFile(file, index, this.props.name);
                                                            }}
                                                        >
                                                            remove <i className="fas fa-times"> </i>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="py-5 text-muted mb-0 jobs-dropzone-placeholder">
                                                Drag and drop, or click to select images related to this job
                                            </p>
                                        )}
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                        {this.props.rejectedFiles?.[this.props.name] && (
                            <p className="text-danger mt-2">Photo size must be less than 15mb</p>
                        )}
                    </div>
                </div>
                </div>

                {/* Modal */}
                {this.state.dtnImageModalOpen && (
                    <DtnPhotoModal
                        media={media}
                        onClose={() => this.setState({ dtnImageModalOpen: false })}
                        index={this.state.dtnImageModalIndex}
                        title={this.props.title}
                    />
                )}
            </Fragment>
        );
    }
}

export default DtnPhotos;
